import { render } from "./DownloadTemplate.vue?vue&type=template&id=5b1075eb"
import script from "./DownloadTemplate.vue?vue&type=script&lang=js"
export * from "./DownloadTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script